import React, { useState, useEffect } from 'react';
import './extracted-data-confirmation.scss';

export interface ExtractedDataField {
  label: string;
  value: string;
}

interface ExtractedDataConfirmationModalProps {
  isOpen: boolean;
  title: string;
  data: ExtractedDataField[];
  onConfirm: (editedData?: ExtractedDataField[]) => void;
  onSaveAndConfirm?: (editedData?: ExtractedDataField[]) => void;
  onCancel?: () => void;
  documentType?: string;
}

export default function ExtractedDataConfirmationModal({
  isOpen,
  title,
  data,
  onConfirm,
  onSaveAndConfirm,
  onCancel,
  documentType,
}: ExtractedDataConfirmationModalProps) {
  const [editedData, setEditedData] = useState<ExtractedDataField[]>([]);

  // Initialize edited data when modal opens or data changes
  useEffect(() => {
    if (isOpen && data) {
      setEditedData(data.map(field => ({ ...field })));
    }
  }, [isOpen, data]);

  const handleFieldChange = (index: number, newValue: string) => {
    const updated = [...editedData];
    updated[index] = { ...updated[index], value: newValue };
    setEditedData(updated);
  };

  const handleConfirm = () => {
    onConfirm(editedData);
  };

  const handleSaveAndConfirm = () => {
    if (onSaveAndConfirm) {
      onSaveAndConfirm(editedData);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="extracted-data-modal-overlay">
      <div className="extracted-data-modal">
        <div className="extracted-data-modal-header">
          <h2>{title}</h2>
          {documentType && (
            <p className="document-type">{documentType}</p>
          )}
        </div>

        <div className="extracted-data-modal-content">
          <p className="confirmation-message">
            هذه هي البيانات المستخرجة من الصورة. من فضلك راجعها واختر أحد الخيارات.
          </p>
          
          <div className="data-fields">
            {editedData.map((field, index) => (
              <div key={index} className="data-field">
                <label className="field-label">{field.label}:</label>
                <input
                  type="text"
                  className="field-value field-input"
                  value={field.value || ''}
                  onChange={(e) => handleFieldChange(index, e.target.value)}
                  placeholder="غير متوفر"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="extracted-data-modal-footer">
          {onCancel && (
            <button
              className="btn-cancel"
              onClick={onCancel}
            >
              إلغاء
            </button>
          )}
          <button
            className="btn-confirm"
            onClick={handleConfirm}
          >
            تأكيد
          </button>
          <button
            className="btn-save-confirm"
            onClick={handleSaveAndConfirm}
          >
            حفظ وتأكيد
          </button>
        </div>
      </div>
    </div>
  );
}

